import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/styles';

// import ChangeCircleIcon from '@material-ui/icons/ChangeCircle';
// import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
// import TranslateIcon from '@mui/icons-material/Translate';
// import SyncIcon from '@mui/icons-material/Sync';
// import RestartAltIcon from '@mui/icons-material/RestartAlt';
// import ReplayIcon from '@mui/icons-material/Replay';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import ReplyIcon from '@mui/icons-material/Reply';
// import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
// import DoneIcon from '@mui/icons-material/Done';

import LanguageIcon from '@mui/icons-material/Language';
// import OutlinedInput from '@mui/material/OutlinedInput';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    // backgroundColor: theme.palette.white,
    // color: theme.palette.black,
    // color: "#FFFFFF",
    // backgroundColor: "#F4623A",
    // backgroundColor: theme.palette.siren_symbol.main,
    backgroundColor: "#2a3f54",
  },
  flexGrow: {
    display: 'flex',
    flexDirection: 'row',
    verticalAlign:'center',
  },
}));


const LangChangeForm = props => {
  const { className, onSidebarOpen, doLogout, user, ...rest } = props;

  const classes = useStyles();

  const [locale, setLocale] = useState(localStorage.getItem("locale") ?? "en-US");
  // const intl = useIntl();

  const handleSubmit = value => {

    // console.log(locale);
    localStorage.setItem("locale", value);
    //화면 refresh
    window.location.href = '/smartcharging';
    // window.location.href = '/';
  }


  return (
    <div className={classes.flexGrow}>
      <LanguageIcon />
    <select
      id="locale"
      value={locale}
      style={{marginLeft:6}}
      // onChange={({ target: { value } }) => setLocale(value)}
      // setLocale(value);
      onChange={({ target: { value } }) => { handleSubmit(value); } }
    >
      <option value="en-US">en-US</option>
      <option value="ko">한국어</option>
      {/* <option value="jp">日本語</option> */}
    </select>

    </div>

  );
};

LangChangeForm.propTypes = {
  className: PropTypes.string,
};



export default LangChangeForm;
